<template>
  <div class="app-review__container">
    <div class="app-review__header">
      <div class="app-review__title">
        {{ title }}
      </div>
      <app-review-star-rating :rating="rating" />
    </div>
    <div class="app-review__message">
      {{ message }}
    </div>
    <div class="app-review__author">{{ author }}, {{ country }}</div>
  </div>
</template>

<script>
import AppReviewStarRating from './AppReviewStarRating'

export default {
  name: 'AppReview',
  components: {
    AppReviewStarRating
  },
  props: {
    title: {
      type: String,
      default: 'Review Title Here'
    },
    message: {
      type: String,
      default: "The user's glowing endorsement of the app goes here."
    },
    author: {
      type: String,
      default: 'User'
    },
    country: {
      type: String,
      default: 'us'
    },
    rating: {
      type: Number,
      default: 4.5,
      validation (rating) {
        return rating >= 0.0 && rating <= 5.0
      }
    }
  }
}
</script>

<style scoped>
.app-review__container {
  display: flex;
  flex-direction: column;
  width: 42rem; /* Roughly the readable width on iPad. */
  margin: 1rem 4rem 1rem 5.44rem;
  flex-grow: 100;
  flex-shrink: 0;
}

.app-review__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.38rem;
  padding: 0 0.35rem;
}

.app-review__title {
  font-family: "Avenir-Black";
  font-size: 1.5rem;
  color: #ff8511;
  letter-spacing: 0;
}

.app-review__message {
  font-family: "Avenir-Medium";
  text-align: left;
  font-size: 1rem;
  color: #332924;
  letter-spacing: 0;
  border-radius: 0.35rem;
  background-color: rgba(155, 155, 155, 0.1);
  padding: 0.25rem 1rem;
}

.app-review__author {
  font-family: "Avenir-Medium";
  font-size: 1rem;
  color: #9b9b9b;
  letter-spacing: 0;
  text-align: left;
  margin-top: 0.5rem;
  padding: 0.1rem 0.75rem;
  width: fit-content;
}

.app-review__author::before {
  content: "~";
}
</style>
